import React, { FC } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Theme, makeStyles } from '@material-ui/core';
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Button
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  content: {
    padding: 0
  },
  dialogContent: {
    minWidth: '400px',
  },
  icon: {
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  isFinalContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  status: {
    marginRight: theme.spacing(1)
  },
  button: {
    margin: theme.spacing(1),
  },
}));

type Props = { 
  paging: Paging,
  setPaging: React.Dispatch<React.SetStateAction<Paging>>,
  totalCount : number,
  batchInfo: BatchInfo,
  setPrecedenceInfo: React.Dispatch<React.SetStateAction<BatchInfo>>,
  batchlist: BatchInfo[]
}

const PrecedenceBatchInfoTable: FC<Props> = ({ paging, setPaging, totalCount, batchInfo, setPrecedenceInfo, batchlist}) => {
  const classes = useStyles();

  const handlePageChange = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
    setPaging({
      ...paging,
      page: page
    });
    // setPage(page);
  };

  const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPaging({
      ...paging,
      rowsPerPage: Number(event.target.value)
    });
    // setRowsPerPage(Number(event.target.value));
  };

  return (
    <Card>
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align='center'>NO.</TableCell>
                  <TableCell align='center'>배치ID</TableCell>
                  <TableCell align='center'>배치명</TableCell>
                  <TableCell align='center'>선택</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {batchlist.slice(0, batchlist.length).map((item, index) => (
                  <TableRow
                    hover
                    key={item.batchSeqNo}
                  >
                    <TableCell align='center'>{(index+1)+(paging.page* paging.rowsPerPage)}</TableCell>
                    <TableCell align='left'>{item.batchId}</TableCell>
                    <TableCell align='left'>{item.batchName}</TableCell>
                    <TableCell align='center'>
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => setPrecedenceInfo({...batchInfo, precedenceBatchId:item.batchId, precedenceBatchName:item.batchName})}
                      >
                         선택
                      </Button>                      
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={totalCount}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={paging.page}
          rowsPerPage={paging.rowsPerPage}
          rowsPerPageOptions={[10, 25, 100]}
        />
      </CardActions>
    </Card>
  );
};

export default PrecedenceBatchInfoTable;
